export enum FloatingButtonState {
  Initial = 'none',
  Enter = 'enter',
  Leave = 'leave',
  RatingCollapse = 'rating_collapse',
  FeedbackCollapse = 'feedback_collapse',
  ThankYouCollapse = 'thank_you_collapse',
  SurveyCollapse = 'survey_collapse',
}
